import MojitoModules from 'mojito/modules';

import {merge} from '#core/utils/config-utils.js';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;

export function getTokens() {
    const palette = {
        [PALETTE_IDS.APPLICATION_HEADER]: {
            APPLICATION_HEADER_NAV_BAR_PAGE_SELECTOR: {
                PIVOT_TEXT: {
                    flexBasis: 'auto',
                    whiteSpace: 'nowrap',
                },
            },
        },
    };

    const tokens = merge({
        custom: {
            [PALETTE_IDS.HOME_PAGE]: {
                MenuLinkPromotions: {
                    container: {
                        style: {
                            marginTop: 8,
                        },
                    },
                    menuRow: {
                        buttonScrollPane: {
                            contentContainer: {
                                style: {
                                    _mobile_padding: '0 0 0 8px',
                                },
                            },
                        },
                    },
                },
                PageContextMenu: {
                    rowLinkMenu: {
                        menuRow: {
                            item: {
                                unselected: {
                                    style: {
                                        base: {
                                            minWidth: 40, // Make quicklink smaller to properly show search button
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            [PALETTE_IDS.MARKETS]: {
                GameLineMarketContent: {
                    selectionNameDisplay: {
                        TOTAL: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT,
                    },
                    participants: {
                        separatorText: {
                            style: {
                                lineHeight: 1.17,
                            },
                        },
                    },
                },
                PriceBoostAggregatedMarket: {
                    titleContainer: {
                        style: {
                            borderRadius: 4,
                            padding: '4px 8px',
                        },
                    },
                },
            },
            [PALETTE_IDS.COUPONS]: {
                TopSports: {
                    navigationMenuContainer: {
                        style: {
                            padding: '8px 0',
                        },
                    },
                },
            },
            [PALETTE_IDS.MOBILE_NAVBAR]: {
                FloatingBetslipPill: {
                    closedBetslipButtonState: {
                        container: {
                            style: {
                                transform: 'translate(0px, calc(-150px - env(safe-area-inset-bottom, 0px)))',
                            },
                        },
                    },
                },
                QuickLinks: {
                    container: {
                        style: {
                            height: 55,
                        },
                    },
                    linkButton: {
                        style: {
                            base: {
                                gap: 4,
                            },
                        },
                    },
                    linkIcon: {
                        style: {
                            minHeight: 24,
                            minWidth: 36,
                        },
                    },
                },
            },
            [PALETTE_IDS.PRE_BUILT_CARDS]: {
                PrebuiltBet: {
                    matchAccaSelectionItem: {
                        marketInfoContainer: {
                            style: {
                                padding: '0 0 8px 0',
                            },
                        },
                    },
                },
                PrebuiltBetBuilder: {
                    headerContainer: {
                        style: {
                            margin: '0 0 4px 0',
                        },
                    },
                    headerTextContainer: {
                        itemSpacing: 4,
                    },
                },
                PrebuiltAcca: {
                    headerContainer: {
                        style: {
                            margin: '0 0 4px 0',
                        },
                    },
                    headerTextContainer: {
                        itemSpacing: 4,
                    },
                },
            },
            [PALETTE_IDS.BET_SHARING_DIALOG]: {
                ShareBetContent: {
                    logo: {
                        style: {
                            maxHeight: 52,
                        },
                    },
                },
                ShareBetslip: {
                    logo: {
                        style: {
                            maxHeight: 52,
                        },
                    },
                },
            },
            [PALETTE_IDS.DESKTOP_CMS_LINKS]: {
                PageContextMenu: {
                    baseLink: {
                        iconContainer: {
                            style: {
                                display: 'none',
                                minWidth: 0, // Hide price boost icon
                            },
                        },
                    },
                    priceBoostLink: {
                        icon: {
                            style: {
                                display: 'none', // Hide price boost icon
                                maxWidth: 0,
                                minWidth: 0,
                                marginRight: 0,
                            },
                        },
                        iconInnerContainer: {
                            style: {
                                display: 'none', // Hide price boost icon
                                maxWidth: 0,
                            },
                        },
                    },
                },
            },
            [PALETTE_IDS.BAD_ROUTE_PAGE]: {
                BadRoutePageView: {
                    logo: {
                        style: {
                            order: -1,
                            width: '266px',
                            height: '186px',
                            _mobile_width: '134',
                            _mobile_height: '94px',
                        },
                        src: 'bad-route/logo.png',
                    },
                    errorCode: {
                        style: {
                            margin: '40px 0',
                            _mobile_margin: '20px 0',
                        },
                    },
                    infoContainer: {
                        style: {
                            borderRadius: '20px',
                            padding: '40px 0',
                            _mobile_padding: '20px 0',
                        },
                    },
                    container: {
                        style: {
                            padding: '120px',
                        },
                    },
                },
            },
            [PALETTE_IDS.SPORTS_CONTENT]: {
                EventsCoupon: {
                    eventList: {
                        eventItem: {
                            itemDetailsGameLine: {
                                participants: {
                                    separatorText: {
                                        style: {
                                            lineHeight: 1.17,
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
                PriceBoostPageView: {
                    pageTitle: {
                        container: {
                            style: {
                                width: 'fit-content',
                                borderRadius: 4,
                                padding: '4px 8px',
                            },
                        },
                    },
                },
            },
        },
        palette,
    });

    return tokens;
}
